export const USER_PREFERENCES = "user_preference";
export const LOCALE = "locale";
export const TOKEN = "token";
